


























































import Vue from 'vue';
import Component from 'vue-class-component';
import {ChallengeModel} from '@/models/challenge.model';
import {UserApi} from '@/api/user.api';
import ChallengeCard from '@/components/ChallengeCard.vue';
import {shareReplay, take} from 'rxjs/operators';
import {publicProfileModule, publicProfileState, userModule, userState} from '@/utils/store-acessor';
import {UserModel} from '@/models/user.model';
import ListScaffold from '@/components/Shared/ListScaffold.vue';
import {bottomVisible} from '@/utils/utils';

@Component({
  components: {
    ListScaffold,
    ChallengeCard
  }
})
export default class ProfileFollowing extends Vue {
  @publicProfileModule.Getter('publicProfile')
  publicProfile!: UserModel;
  @userModule.Getter('user') user!: UserModel;
  challenges: ChallengeModel[] = [];
  page = 1;
  total = 0;
  lastPage = 1;
  loading: boolean = false;
  publicFollowingLoading: boolean = false;
  isPublic: boolean = false;
  profileName: string | undefined = '';

  mounted() {
    window.addEventListener('scroll', () => {
      if (bottomVisible() ||  this.challenges?.length < this.total) {
        this.scrollInBottom()
      }
    })
    this.isPublic = this.$route.params.slug !== 'me';
    this.loading = true;
    if (this.$route.params.slug === 'me') {
      this.getMeFollowingChallenges();
    } else {
      this.getPublicFollowingChallenges(this.$route.params.slug);
    }

  }

  async getMeFollowingChallenges() {
    await userState.fetchUser();
    if (this.user?.slug) {
      this.loading = true;
      this.fetchFollowedChallenges(this.user.slug, this.page);
    }
  }

  async getPublicFollowingChallenges(slug: string) {
    this.loading = true;
    this.publicFollowingLoading = true;
    try {
      if (!this.publicProfile?.id) {
        await publicProfileState.fetchPublicProfile(slug);
      }
      this.profileName = this.publicProfile?.full_name;
      this.fetchFollowedChallenges(slug, this.page);
      this.publicFollowingLoading = false;
    } catch (e) {
      this.loading = true;
      this.publicFollowingLoading = false;
    }
  }

  private fetchFollowedChallenges(slug: string, page: number): void {
    new UserApi()
            .followedChallenges(slug, {page})
            .pipe(take(1))
            .subscribe((challenges) => {
              this.loading = false;
              this.challenges = challenges.data;
              this.page = challenges.current_page;
              this.total = challenges.total;
              this.lastPage = challenges.last_page;
            }, () => {
              this.loading = false;
              this.publicFollowingLoading = false;
            });
  }

  openChallenge(slug: string) {
    this.$router.push({path: `/challenges/${slug}`});
  }

  scrollInBottom() {
    if ((this.page < this.lastPage) && !this.loading) {
      if (this.$route.params.slug !== 'me') {
        this.fetchFollowedChallenges(this.$route.params.slug, this.page + 1);
      } else if(this.user.slug) {
        this.fetchFollowedChallenges(this.user.slug, this.page + 1);
      }
    }
  }
}
